<template>
    <div class="dashboard-wrap">
        <h1 class="dashboard-title">
            <span>Пополнить баланс</span>
            <router-link to="/dashboard/payment-services/259" class="button md-block">Вывод на карту</router-link>
        </h1>
    </div>
    <div class="tab-arrow">
        <div class="tab horizontal account default-color">
            <router-link to="/dashboard/refill/cryptocurrency" class="tab-button">Криптовалюты</router-link>
            <router-link to="/dashboard/refill/fiat" class="tab-button">Фиат</router-link>
            <router-link to="/dashboard/refill/terminals" class="tab-button">Терминалы</router-link>
            <router-link to="/dashboard/refill/cash" class="tab-button">Swift</router-link>
        </div>
    </div>
    <div class="dashboard-wrap">
        <div class="dashboard-list">
            <div class="row">
                <template v-if="category === 'cryptocurrency' && currencies">
                    <template v-for="item in currencies" :key="item">
                        <div class="col-6 col-md-4 col-lg-3 col-xl-3" v-if="item.can_deposit === true">
                            <div class="list-item" v-on:click="getDepositAddress(item)">
                                <img :src="item.logo" :alt="item.name">
                                <div class="list-item-wrap">
                                    <div>
                                        <b>{{ item.currency }}</b>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-if="category === 'fiat'">
                    <div class="d-flex mb-3 gap-3">
                        <span class="button lg" :class="currency !== 'KGS' && 'button-default'" v-on:click="currency = 'KGS'" role="button">KGS</span>
                        <span class="button lg" :class="currency !== 'USD' && 'button-default'" v-on:click="currency = 'USD'" role="button">USD</span>
                    </div>
                    <template v-for="item in getMethods" :key="item">
                        <div class="col-6 col-md-6 col-lg-6 col-xl-4" v-if="item.currency === currency">
                            <div class="list-item" v-on:click="getMethodDetail(item)">
                                <img :src="item.logo" :alt="item.name">
                                <div class="list-item-wrap">
                                    <div>
                                        <b>{{ item.currency }}</b>
                                        <span class="active">{{ item.name }}</span>
                                    </div>
                                    <a class="list-item-button">{{ item.commission }}%</a>
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
                <template v-if="category === 'terminals'">
                    <div class="col-6 col-md-6 col-lg-6 col-xl-4" v-for="item in getMethods" :key="item">
                        <div class="list-item" v-on:click="getMethodDetail(item)">
                            <img :src="item.logo" :alt="item.name">
                            <div class="list-item-wrap">
                                <div>
                                    <b>{{ item.currency }}</b>
                                    <span class="active">{{ item.name }}</span>
                                </div>
                                <a class="list-item-button">{{ item.commission }}%</a>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="category === 'cash'">
                    <div class="col-6 col-md-6 col-lg-6 col-xl-4" v-for="item in getMethods" :key="item">
                        <div class="list-item" v-on:click="getMethodDetail(item)">
                            <img :src="item.logo" :alt="item.name">
                            <div class="list-item-wrap">
                                <div>
                                    <b>{{ item.currency }}</b>
                                    <span class="active">{{ item.name }}</span>
                                </div>
                                <a class="list-item-button">{{ item.commission }}%</a>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="modal-window" v-if="modalStatus">
            <div class="modal-close" v-on:click="closeModal"></div>
            <div class="modal-content modal-refill-crypto" v-if="category === 'cryptocurrency'">
                <div class="modal-close-btn" v-on:click="closeModal"></div>
                <h1 class="modal-title text-center">{{ detail.name }} депозитный адрес</h1>
                <p class="modal-text" v-html="info.info?.description"></p>
                <div class="form">
                    <div class="modal-qr-image">
                        <img :src="depositAddress.qrcode_url" :alt="detail.name">
                    </div>
                    <label class="form-label">Выберите сеть</label>
                    <div class="form-group mb-3">
                        <select class="form-input" v-on:change="setNetwork($event)" :disabled="loading">
                            <template v-for="(item, index) in networks" :key="index">
                                <option :value="item.network" :selected="item.network === 'TRC20'">{{ item.name }} MIN: {{ item.min_deposit }} {{ detail.currency }}</option>
                            </template>
                        </select>
                    </div>
                    <label class="form-label">{{ detail.name }} {{ detail.currency }} Адрес</label>
                    <div class="form-group mb-3 position-relative">
                        <input type="text" class="form-input default-input" :value="depositAddress.deposit_address" ref="address" readonly :disabled="loading">
                        <span class="form-icon icon-reload ease" v-on:click="generateDepositAddress" :class="loading && 'active'"></span>
                    </div>
                    <template v-if="depositAddress && depositAddress?.deposit_address_memo">
                        <label class="form-label">MEMO Адрес</label>
                        <div class="form-group mb-3 position-relative">
                            <input type="text" class="form-input default-input" :value="depositAddress.deposit_address_memo" ref="memo" readonly :disabled="loading">
                            <span class="form-icon icon-paste ease" v-on:click="copy('memo')"></span>
                        </div>
                    </template>
                    <div class="text-center">
                        <button class="button d-inline-block lg mt-2" v-on:click="copy('address')" :disabled="loading">Скопировать</button>
                    </div>
                </div>
            </div>
            <div class="modal-content" v-if="category === 'fiat' && !fiatDetail">
                <h1 class="modal-title text-center mb-4">Пополнить через "{{ detail.name }}"</h1>
                <template v-if="!detail.info.description">
                    <div class="modal-wrap">
                        <div class="row">
                            <div class="col-12 col-md-6 m-mb">
                                <div class="profile-info-column mt-0 icon-none">
                                    <div>
                                        <span>Минимальная сумма</span>
                                        <b>{{ detail.min_qty }} {{ detail.currency }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 m-mb">
                                <div class="profile-info-column mt-0 icon-none">
                                    <div>
                                        <span>Максимальная сумма</span>
                                        <b>{{ detail.max_qty }} {{ detail.currency }}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row pt-3">
                            <div class="col-12 col-md-6">
                                <div class="profile-info-column mt-0 icon-none">
                                    <div>
                                        <span>Комиссия</span>
                                        <b>{{ detail.commission }}%</b>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="profile-info-column mt-0 icon-none">
                                    <div>
                                        <span>Курс</span>
                                        <b class="text-success">1.00 USDT = {{ detail.rate }} {{ detail.currency }}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form mt-4">
                        <label class="form-label">Введите сумму в <b>{{ detail.currency }}</b></label>
                        <div class="form-group mb-2">
                            <input type="tel" inputmode="decimal" step="any" class="form-input" v-model="amount" placeholder="Введите сумму" required>
                        </div>
                        <template v-if="detail.slug == 'otpmegapay'">
                            <label class="form-label">Введите номер телефона</label>
                            <div class="form-group">
                                <input type="tel" inputmode="decimal" step="any" class="form-input" v-model="account" placeholder="996ХХХ ХХ ХХ ХХ">
                            </div>
                        </template>
                        <button class="button block lg mt-4" v-on:click="createFiatMethod" :disabled="loading">Продолжить</button>
                    </div>
                </template>
                <template v-else>
                    <div class="modal-wrap">
                        <p class="modal-text text-center" v-html="detail.info.description"></p>
                        <button class="button block lg" v-on:click="closeModal">Закрыть</button>
                    </div>
                </template>
            </div>
            <div class="modal-content d-block" v-if="category === 'fiat' && fiatDetail">
                <h1 class="modal-title text-center mb-3">Подтверждение платежа</h1>
                <div class="dashboard-table px-0">
                    <div class="dashboard-table-row table-row-v2">
                        <div class="dashboard-table-column">Сумма к зачислению</div>
                        <div class="dashboard-table-column">{{ fiatDetail.confirm.debit }} USDT</div>
                    </div>
                    <div class="dashboard-table-row table-row-v2">
                        <div class="dashboard-table-column">Сумма к оплате</div>
                        <div class="dashboard-table-column">{{ fiatDetail.confirm.amount }} {{ fiatDetail.confirm.currency }}
                        </div>
                    </div>
                    <div class="dashboard-table-row table-row-v2">
                        <div class="dashboard-table-column">Комиссия</div>
                        <div class="dashboard-table-column">{{ fiatDetail.confirm.commission }} {{ fiatDetail.confirm.currency }}</div>
                    </div>
                    <div class="dashboard-table-row table-row-v2">
                        <div class="dashboard-table-column">Курс</div>
                        <div class="dashboard-table-column text-success">1.00 USDT = {{ detail.rate }} {{ detail.currency }}</div>
                    </div>
                </div>
                <AnyBank v-if="fiatDetail?.confirm && (detail.slug == 'anybank' || detail.slug == 'anybankusd')" :detail="fiatDetail?.confirm" />
                <MBusiness v-if="fiatDetail?.confirm && detail.slug == 'mbusiness'" :detail="fiatDetail?.confirm" />
                <QRMBank v-if="fiatDetail?.confirm && detail.slug == 'qrmbank'" :detail="fiatDetail?.confirm" />
                <QRBakai v-if="fiatDetail?.confirm && detail.slug == 'qrbakai'" :detail="fiatDetail?.confirm" />
                <MKassa v-if="fiatDetail?.confirm && detail.slug == 'mkassa'" :detail="fiatDetail?.confirm" />
                <KSB v-if="fiatDetail?.confirm && detail.slug == 'qrksb'" :detail="fiatDetail?.confirm" />
                <OnoiQR v-if="fiatDetail?.confirm && detail.slug == 'onoiqr'" :detail="fiatDetail?.confirm" />
                <template v-if="detail.slug == 'otpmegapay'">
                    <label class="form-label mt-2">Введите код подтверждения</label>
                    <div class="form-group mb-4">
                        <input type="number" class="form-input" v-model="otpcode" placeholder="Код" autofocus>
                    </div>
                    <button class="button block lg mb-2" v-on:click="confirmOTPMegaPay" :disabled="loading">Подтвердить</button>
                </template>
                <div class="custom-form" v-if="fiatDetail.form" v-html="fiatDetail.form"></div>
            </div>
            <div class="modal-content" v-if="category === 'terminals'">
                <h1 class="modal-title text-center mb-4">Пополнить через "{{ detail.name }}"</h1>
                <p class="modal-text" v-html="detail.info.description"></p>
                <button class="button block lg" v-on:click="closeModal">Закрыть</button>
            </div>
            <div class="modal-content" v-if="category === 'cash'">
                <h1 class="modal-title text-center mb-4">Пополнить через "{{ detail.name }}"</h1>
                <p class="modal-text text-center" v-html="detail.info.description"></p>
                <button class="button block lg" v-on:click="closeModal">Закрыть</button>
            </div>
        </div>
    </div>
    <div class="modal-window" v-if="IPDSStatus">
        <div class="modal-close"></div>
        <div class="modal-content padding-none">
            <div class="p-3">
                <h1 class="modal-title">Анкета</h1>
            </div>
            <form class="form position-relative z-index" autocomplete="off">
                <SurveyComponent :model="survey" @onSubmit="handleSurvey" />
            </form>
        </div>
    </div>
</template>

<script>
import MBusiness from '@/components/Account/Refill/MBusiness'
import AnyBank from '@/components/Account/Refill/AnyBank'
import QRMBank from '@/components/Account/Refill/QRMBank'
import QRBakai from '@/components/Account/Refill/QRBakai'
import MKassa from '@/components/Account/Refill/MKassa'
import KSB from '@/components/Account/Refill/KSB'
import OnoiQR from '@/components/Account/Refill/OnoiQR'

import { Model } from 'survey-core'
import "survey-core/i18n/russian"
import { LayeredDarkPanelless } from "survey-core/themes"
import 'survey-core/defaultV2.min.css'

export default {
    data() {
        return {
            IPDSStatus: false,
            modalStatus: false,
            category: '',
            detail: '',
            amount: '',
            currency: 'KGS',
            info: '',
            intervalId: false,
            network: '',
            networks: '',
            account: '',
            otpcode: '',
            ipds_data: new FormData()
        }
    },
    components: {
        MBusiness,
        AnyBank,
        QRMBank,
        QRBakai,
        MKassa,
        KSB,
        OnoiQR
    },
    created() {
        this.getCurrentCategory()
        this.$store.dispatch('getProfile')
        if (this.$route.query['currency']) {
            this.$store.dispatch('getCurrencies')
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        profile() {
            return this.$store.getters.getProfile
        },
        currencies() {
            return this.$store.getters.getCurrencies
        },
        getMethods() {
            return this.$store.getters.getMethods
        },
        depositAddress() {
            return this.$store.getters.getDepositAddress
        },
        fiatDetail() {
            return this.$store.getters.getFiatMethod
        },
        getMKassaPaymentStatus() {
            return this.$store.getters.getMKassaPaymentStatus
        }
    },
    watch: {
        profile() {
            if(this.profile.ipds_status !== true) {
                this.IPDSStatus = true
                this.createSurvey()
            }
        },
        $route() {
            this.getCurrentCategory()
        },
        currencies() {
            if (this.$route.query['currency']) {
                this.getDepositAddress(this.filterCurrency(this.currencies, this.$route.query['currency']))
            }
        },
        depositAddress() {
            this.showModal()
        },
        fiatDetail() {
            if (this.fiatDetail && this.fiatDetail.confirm.qrCode !== '' && this.fiatDetail.confirm?.tracking === true) {
                this.checkMKassaPayment()
            }
        },
        getMKassaPaymentStatus() {
            if (this.getMKassaPaymentStatus.status.value == '2') {
                this.$store.dispatch('notification', { message: 'Оплата прошла успешно!', type: 'success' })
                this.$store.dispatch('clearFiatMethod')
                this.$router.push('/dashboard/operations')
                clearInterval(this.intervalId)
            }
            if (this.getMKassaPaymentStatus.status.value == '3') {
                this.$store.dispatch('notification', { message: 'Оплата отменена!' })
                this.$store.dispatch('clearFiatMethod')
                this.$router.push('/dashboard/operations')
                clearInterval(this.intervalId)
            }
        },
        getMethods() {
            // const list = []
            // console.log(JSON.parse(JSON.stringify(this.getMethods)))
            // Array(this.getMethods).forEach((element, index) => {
            //     console.log(element)
            //     console.log(index)
            // })
        }
    },
    methods: {
        createSurvey() {
            const surveyJson = {
                showQuestionNumbers: true,
                goNextPageAutomatic: false,
                firstPageIsStarted: true,
                pages: [
                    {
                        elements: [
                            {
                                "type": "radiogroup",
                                "name": "survey",
                                "title": "Предоставьте сведения о происхождении средств",
                                "choices": [
                                    { "value": 1, "text": "Личные сбережения"},
                                    { "value": 2, "text": "Продажа движимого/недвижимого имущества"},
                                    { "value": 3, "text": "Cредства взятые в кредит"},
                                    { "value": 4, "text": "Доход от бизнеса/заработной платы"},
                                    { "value": 5, "text": "Наследство"},
                                ],
                                "showOtherItem": true,
                                "isRequired": true
                            },
                            {
                                type: "file",
                                name: "proofDocument",
                                title: "Загрузите подтверждающий документ",
                                storeDataAsText: false,
                                allowMultiple: false,
                                // isRequired: true,
                                maxSize: 10240000, // 1 MB в байтах
                                acceptedTypes: "application/pdf, image/*",
                                css: "small-file"
                            }
                        ]
                    }
                ]
            }
            this.survey = new Model(surveyJson)
            this.survey.locale = "ru"
            this.survey.applyTheme(LayeredDarkPanelless)
            this.survey.onUploadFiles.add(async (_, options) => {
                const files = options.files
                this.ipds_data.append("file", files[0])
                const result = files.map((file) => ({
                    file: {
                    name: file.name,
                    type: file.type,
                    content: URL.createObjectURL(file) // временный локальный preview
                    }
                }));

                // обязательно вызываем callback!
                options.callback(result)
            })
            this.survey.onComplete.add((sender) => {
                this.handleSurvey(sender.data)
            })
        },
        handleSurvey(data) {
            this.ipds_data.append('status', data.survey !== undefined ? data.survey : '')
            this.ipds_data.append('comment', data['survey-Comment'] !== undefined ? data['survey-Comment'] : '')
            console.log(this.ipds_data)
            this.$store.dispatch('updateIPDSStatus', this.ipds_data)
            localStorage.setItem('IPDS', 'passed')
            this.IPDSStatus = false
        },
        filterCurrency(list, currency) {
            return list.find((el) => { return el.currency == currency })
        },
        showModal() {
            this.modalStatus = true
        },
        closeModal() {
            this.modalStatus = false
            if (this.category === 'fiat') {
                this.amount = ''
                this.$store.dispatch('clearFiatMethod')
            }
        },
        getCurrentCategory() {
            this.category = this.$router.currentRoute.value.params.category
            if (this.category !== undefined) {
                this.$store.dispatch('getMethods', this.category)
            }
        },
        getDepositAddress(item) {
            this.detail = item
            this.networks = item.networks
            if (this.getMethods !== '' && this.getMethods !== undefined) {
                this.info = Object.values(this.getMethods).find((el) => { return el.currency == item.currency })
                this.$store.dispatch('getDepositAddress', {slug: item?.slug})
            }
        },
        getMethodDetail(item) {
            this.detail = item
            this.showModal()
        },
        createFiatMethod() {
            if (this.amount < this.detail.min_qty) {
                this.$store.dispatch('notification', { message: 'Минимальная сумма пополнения ' + this.detail.min_qty + ' ' + this.detail.currency })
            } else {
                const data = {
                    sum: this.amount,
                    method: this.detail.slug,
                    account: this.account
                }
                this.$store.dispatch('createFiatMethod', data)
            }
        },
        copy(ref, value = '') {
            if(value) {
                navigator.clipboard.writeText(value)
            } else {
                this.$refs[ref].select()
                document.execCommand('copy')
                this.$refs[ref].blur()
                window.getSelection().removeAllRanges()
                this.$store.dispatch('notification', { message: 'Скопировано', type: 'success' })
            }
        },
        checkMKassaPayment() {
            const self = this
            this.intervalId = setTimeout(() => {
                self.$store.dispatch('checkMKassaPayment', { 'guid': self.fiatDetail.confirm.id })
                this.checkMKassaPayment()
            }, 5000)
        },
        setNetwork(event) {
            this.network = event.target.value
            this.$store.dispatch('getDepositAddress', {slug: this.detail?.slug, network: this.network})
        },
        generateDepositAddress() {
            this.$store.dispatch('getDepositAddress', {slug: this.detail?.slug, network: this.network, generate: 'new'})
        },
        confirmOTPMegaPay() {
            const data = {
                guid: this.fiatDetail?.confirm?.id,
                code: this.otpcode
            }
            this.$store.dispatch('confirmOTPMegaPay', data)
        }
    }
}
</script>